import Vue from 'vue'
import Vuex from 'vuex'
const customer = require('./shops/' + process.env.VUE_APP_SHOP + '.json');

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    customer
  },
  mutations: {

  },
  actions: {

  }
})
